import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from '../../models/user';
import { GlobalProvider } from '../../providers/global/global'
import { ClientPage } from '../client/client';
import { stringify } from '@angular/core/src/util';


@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  user = {} as User;
  data: Observable<any>;
  manterSessao: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public menuCtrl: MenuController,
    public global: GlobalProvider) {

    this.menuCtrl.enable(false, 'myMenu');
    
    //Tentar reconexao
    try{
      var url = 'http://iot.digicomp.com.br/api/public/ping/refresh';

      if(localStorage.getItem('storedLogin') === "1"){
        this.global.rf_token= localStorage.getItem('storedrf');
        this.global.userId= this.global.userName;
        
        let body = new FormData();
        body.append('rft', this.global.rf_token);
        this.data = this.http.post(url, body);
        this.data.subscribe(data => {
          if (data.login) {
            let jwt=JSON.parse(atob(data.jwt.split(".")[1]));
            this.global.userId = jwt.sub;
  
            this.global.activeSession = data.login;
  
            this.global.securityLevel = jwt.sec;
  
            this.global.permissions = [];
            for (let i = 0; i < jwt.per.split(';').length; i++) {
              this.global.permissions[i] = jwt.per.split(';')[i];
            }
  
            this.global.notifications = [];
            for (let i = 0; i < jwt.are.split(';').length; i++) {
              this.global.notifications[i] = jwt.are.split(';')[i];
            }
  
            this.global.token = data.jwt;
            this.global.rf_token = data.rft;
            this.global.token_exp = jwt.exp;
            localStorage.setItem('storedrf', this.global.rf_token);
    
            this.navCtrl.setRoot(ClientPage);
          }
          else {
            this.global.activeSession = data.login;
          }
        });
      }
    }
    catch (e){
      console.error(e);
    }
  }

  login(user: User) {

    //login regular
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/login';
      user.password=btoa(user.password+"fb01c973-aed3-4adc-80da-b1f6b0f1946a");
      let ttt="";
      for (let i = 0; i < user.password.length; i=i+2) {
        ttt = ttt+user.password[i];
      }
      for (let i = 1; i < user.password.length; i=i+2) {
        ttt = ttt+user.password[i];
      }
      user.password=ttt;
      let body = new FormData();
      body.append('userName', user.userName);
      body.append('password', user.password);
      body.append('regId', this.global.regId);
      body.append('device_type', this.global.devicePlatform);
      this.data = this.http.post(url, body);
      console.log(this.data);
      this.data.subscribe(data => {
        //console.log(data);
        document.getElementById("result").innerHTML = data.result;
        if (data.login) {
          let jwt=JSON.parse(atob(data.jwt.split(".")[1]));
          this.global.userId = user.userName;

          this.global.activeSession = data.login;

          this.global.securityLevel = jwt.sec;

          this.global.permissions = [];
          for (let i = 0; i < jwt.per.split(';').length; i++) {
            this.global.permissions[i] = jwt.per.split(';')[i];
          }

          this.global.notifications = [];
          for (let i = 0; i < jwt.are.split(';').length; i++) {
            this.global.notifications[i] = jwt.are.split(';')[i];
          }

          this.global.token = data.jwt;
          this.global.rf_token = data.rft;
          this.global.token_exp = jwt.exp;

          if(this.manterSessao){
            localStorage.setItem('storedLogin', "1");
            localStorage.setItem('storedrf', this.global.rf_token);
          } else {
            localStorage.setItem('storedLogin', null);
            localStorage.setItem('storedrf', null);
          }

          this.navCtrl.setRoot(ClientPage);
        }
        else {
          this.global.activeSession = data.login;
        }
      },
      (err)=>{
        console.log(err);
        document.getElementById("result").textContent = "Erro! Tente novamente mais tarde";
      }
      );
      
    }
    catch (e) {
      console.error(e);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts